// extracted by mini-css-extract-plugin
export default {"fullWidth":"xn-z","image":"yn-z","lazyLoadPicture":"zn-z","lazyLoadSpinner":"An-z","lazyLoadSpin":"Bn-z","lazyLoadImage":"Cn-z","hasStyledAspectRatio":"Dn-z"};